import React from 'react';
import './Trending.scss';

import im0 from'../../../images/4.jpg';
import im1 from'../../../images/5.jpg';
import im2 from'../../../images/6.jpg';
import im3 from'../../../images/7.jpg';

function sort_by_kpi(kpi){
    var page = window.location.href;
    var to_display = "block";
    if(page.search("#") === -1){
        return to_display;
    }
    var kpi_filter = page.split("#").pop().toUpperCase().replace(/\s/g,'');
    var clean_kpi = kpi.replace(/\s/g,'');
    if(clean_kpi === kpi_filter){
        return to_display;
    }
    to_display = "none";
    return to_display;
}

const Trending = props => {
    var trending = [];
    var images = [im0, im1, im2, im3]
    for (var i = 0; i < props.trending.length; i++) {
        trending.push(
            <div style={{display: sort_by_kpi(props.trending[i].KPI)}}className="cellTrending">
                <div>
                    <img className="trendingImage" alt="" src={images[i]} />
                </div>
                <div>
                    <a href="http://google.com">
                        <div className="smallTopicTrending">{props.trending[i].title}</div>
                    </a>
                    <span className="trendingCompany"> {props.trending[i].company} </span>
                    <span className="trendingLine"> | </span>
                    <span className="trendingKPI"> {props.trending[i].KPI}</span>
                </div>
            </div>);
    }  
    return (
        <div className="trending-card">
            <div className="cell">
                <div className="trendingTitle">Trending</div>
                <div >{trending}</div>
            </div>
        </div>
    )
};

export default Trending;